export default __webpack_public_path__ + "static/media/download.117f4671.svg";